export const COMPONENT_NAME = 'Pillar Carousel';
